import type { RouteObject } from "react-router";

import { PageHeading } from "@prequel/shared-components";

import ActivityTable from "./ActivityTable";

import Breadcrumbs from "@/components/Breadcrumbs";

const ActivityLayout = () => (
  <div className="h-full flex-col">
    <div className="max-w-6xl px-7 py-4 pb-16">
      <PageHeading title="Activity" breadcrumbs={<Breadcrumbs />} />
      <ActivityTable />
    </div>
  </div>
);

export const activityRouteChildren: RouteObject = {
  path: "activity",
  handle: {
    breadcrumb: () => ({ label: "Activity" }),
  },
  element: <ActivityLayout />,
};
